var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-16.0%",
    width: "140.0%",
    height: "140.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.02 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gloepid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-page---chat-1",
    transform: "translate(-1094.000000, -878.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1100.000000, 722.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-picture"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#486FFA",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(25.500000, 23.000000) rotate(-360.000000) translate(-25.500000, -23.000000) translate(12.000000, 6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3211003,18.1587808 L25.3211003,14.7189789 C25.3211012,13.5996379 24.8594571,12.526142 24.0377246,11.7346484 C23.2159922,10.9431548 22.1014835,10.4984988 20.9393783,10.4984996 L17.3681593,10.4984996 C17.3681593,10.0341788 15.8190049,9.65375052 13.8505124,9.61769631 L13.8505124,5.46949839 C15.1323486,5.31394509 16.0677909,4.22535865 15.9868841,2.98337475 C15.9059772,1.74139085 14.8365998,0.773969851 13.5446303,0.773969851 C12.2526608,0.773969851 11.1832835,1.74139085 11.1023766,2.98337475 C11.0214697,4.22535865 11.956912,5.31394509 13.2387474,5.46949839 L13.2387474,9.61769631 C11.2702557,9.65375215 9.72110131,10.0341722 9.72110131,10.4984996 L5.53811649,10.4984996 C4.37601128,10.4984988 3.26150263,10.9431548 2.43977016,11.7346484 C1.61803769,12.526142 1.15639359,13.5996379 1.15639449,14.7189789 L1.15639449,18.1587808 C0.649589352,18.1587808 0.238747389,19.807637 0.238747389,21.8416088 C0.238747389,23.8755805 0.649589352,25.5244368 1.15639449,25.5244368 L1.15639449,29.5534906 C1.15639359,30.6728315 1.61803769,31.7463275 2.43977016,32.537821 C3.26150263,33.3293146 4.37601128,33.7739699 5.53811649,33.7739699 L20.9393783,33.7739699 C22.1014835,33.7739699 23.2159922,33.3293146 24.0377246,32.537821 C24.8594571,31.7463275 25.3211012,30.6728315 25.3211003,29.5534906 L25.3211003,25.5244368 C25.8279054,25.5244368 26.2387474,23.8755789 26.2387474,21.8416088 C26.2387474,19.8076387 25.8279054,18.1587808 25.3211003,18.1587808 Z",
    id: "Path",
    fill: "#E5EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19400558,11.2459769 L20.2156017,11.2459769 C22.4187742,11.2459769 24.2047984,12.9508182 24.2047984,15.0538465 L24.2047984,28.4381074 C24.2047984,29.4480172 23.7845093,30.4165637 23.0363898,31.1306778 C22.2882703,31.8447918 21.2736025,32.2459769 20.2156017,32.2459769 L6.19399514,32.2459769 C3.99082264,32.2459769 2.20479844,30.5411357 2.20479844,28.4381074 L2.20479844,15.0538565 C2.20479844,12.9508231 3.99082771,11.2459769 6.19400558,11.2459769 L6.19400558,11.2459769 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29577532,21.867031 C6.63969526,21.8652636 5.29764091,20.5938446 5.29577532,19.024926 C5.29577532,18.937723 5.37039471,18.867031 5.46244239,18.867031 C5.55449008,18.867031 5.62910947,18.937723 5.62910947,19.024926 C5.62910947,20.4201702 6.82301644,21.5512392 8.29577532,21.5512392 C9.7685342,21.5512392 10.9624412,20.4201702 10.9624412,19.024926 C10.9624412,18.937723 11.0370606,18.867031 11.1291082,18.867031 C11.2211559,18.867031 11.2957753,18.937723 11.2957753,19.024926 C11.2939097,20.5938432 9.95185762,21.8652616 8.29577532,21.867031 Z",
    id: "Path",
    fill: "#486FFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,29 C11.8439171,28.9982666 10.5018585,27.7456793 10.5,26.2000004 C10.5,26.0895432 10.5959392,26 10.7142861,26 C10.8326331,26 10.9285723,26.0895432 10.9285723,26.2000004 C10.9285723,27.5254843 12.0798402,28.6000013 13.5,28.6000013 C14.9201622,28.6000013 16.0714301,27.5254843 16.0714301,26.2000004 C16.0714301,26.0895439 16.1673687,26 16.285715,26 C16.4040614,26 16.5,26.0895439 16.5,26.2000004 C16.4981428,27.7456789 15.1560849,28.9982666 13.5,29 L13.5,29 Z",
    id: "Path",
    fill: "#486FFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5847865,21.4979128 C16.9287065,21.4961454 15.5866521,20.2247264 15.5847865,18.6558079 C15.5847865,18.5686049 15.6594059,18.4979128 15.7514536,18.4979128 C15.8435013,18.4979128 15.9181207,18.5686049 15.9181207,18.6558079 C15.9181207,20.0510521 17.1120277,21.1821211 18.5847865,21.1821211 C20.0575454,21.1821211 21.2514524,20.0510521 21.2514524,18.6558079 C21.2514524,18.5686049 21.3260718,18.4979128 21.4181195,18.4979128 C21.5101671,18.4979128 21.5847865,18.5686049 21.5847865,18.6558079 C21.5828925,20.2247139 20.240857,21.4961166 18.5847865,21.4979128 L18.5847865,21.4979128 Z",
    id: "Path",
    fill: "#486FFA"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#486FFA",
    cx: 8.30426256,
    cy: 19.2490292,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#486FFA",
    cx: 18.5932738,
    cy: 18.8799111,
    r: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/bot-icon.d9879cdc1b42cf89ca8a35ad1cf449e3.svg";
export { ForwardRef as ReactComponent };